import Location from "@/scenes/location";
import GameApp from "../../../index";
import gameApp from "../../../index";

export class ChatHandler {
  static handle({
    sender,
    type,
    duration,
    action,
    title,
    message,
    username,
    isTyping,
  }: {
    sender: string;
    message: string;
    type: string;
    action: string;
    title: string;
    duration: string;
    username: string;
    isTyping: boolean;
  }) {
    const scene = GameApp.game.currentScene as Location;

    switch (action) {
      case "mute":
        const chatboxElement = document.querySelector("chat-box") as any;
        chatboxElement?.setMute(parseFloat(duration) * 60 * 1000);

        gameApp.dashboard?.customAlert.openAlert(title, message);
        break;

      case "kicked":
        scene.clear();
        gameApp.dashboard?.customAlert.openAlert("", "");
        break;

      default:
        const currentScene = this.getCurrentScene();
        const player = this.getPlayerFromScene(currentScene, sender);

        this.addChatToPlayer(player, message, isTyping);

        if (isTyping === null) this.dispatchChatEvent(username, message);
        break;
    }
  }

  // Get the current scene from the game
  private static getCurrentScene(): Location | null {
    return (GameApp.game.currentScene as Location) || null;
  }

  // Get a player from the scene using their ID
  private static getPlayerFromScene(scene: Location | null, sender: string) {
    return scene?.figureManager.getFigureById(sender) || null;
  }

  // Add a chat message to the player's figure
  private static addChatToPlayer(
    player: any,
    message: string,
    isTyping: boolean = false
  ) {
    player?.figure?.addChat(message, isTyping);
  }

  // Dispatch the "add-message" event to the chat history
  private static dispatchChatEvent(username: string, message: string) {
    const chatEvent = new CustomEvent("add-message", {
      detail: { user: username, message },
      bubbles: true,
      composed: true,
    });

    document.querySelector("chat-history")?.dispatchEvent(chatEvent);
  }
}
